export type LocalizedValue = string | Record<string, string> | null | undefined

/** Resolve a localized API value using the locale selected by the current route. */
export const resolveLocalizedValue = (
  value: LocalizedValue,
  locale: string,
): string => {
  if (!value) return ''
  if (typeof value === 'string') return value
  return typeof value[locale] === 'string' ? value[locale] : ''
}
